import { ContentWrapper } from "@/components/layout/content";
import { GlitchText } from "@/components/ui/GlitchText";

export function ValuePropsSection() {
  return (
    <section className="py-24 bg-transparent" id="capabilities">
      <ContentWrapper>
        <div className="mb-16">
          <h2 className="text-4xl md:text-5xl font-mono font-bold text-gray-50 mb-6">
            <GlitchText text="Das zeichnet mich aus" glitchClassName="text-emerald-400" />
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Box 1 */}
          <div className="bg-gray-950 border border-gray-800 p-8 rounded-sm font-mono relative overflow-hidden group hover:border-emerald-400/50 transition-colors">
            <div className="absolute top-0 left-0 w-full h-1 bg-linear-to-r from-emerald-500 to-emerald-900 opacity-50"></div>
            <div className="flex items-center gap-4 mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-6 h-6 text-emerald-400 shrink-0"
              >
                <path d="m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z" />
                <path d="m5 3 1 2.5L8.5 6 6 7 5 9.5 4 7 1.5 6 4 5.5z" />
                <path d="m19 17 1 2.5 2.5.5-2.5 1-1 2.5-1-2.5-2.5-1 2.5-1z" />
              </svg>
              <h3 className="text-lg md:text-xl text-gray-50 font-bold leading-snug">
                Lösungen so individuell wie Ihr Erfolg
              </h3>
            </div>
            <p className="text-gray-400 font-sans text-sm leading-relaxed">
              Standardlösungen von der Stange gibt es genug. Ihr Unternehmen verdient einen
              digitalen Auftritt, der genauso einzigartig ist wie Ihr Erfolg. Ich entwickle
              maßgeschneiderte Konzepte, die ab dem ersten Klick überzeugen und nachhaltig im Kopf
              bleiben.
            </p>
          </div>

          {/* Box 2 */}
          <div className="bg-gray-950 border border-gray-800 p-8 rounded-sm font-mono relative overflow-hidden group hover:border-cyan-400/50 transition-colors">
            <div className="absolute top-0 left-0 w-full h-1 bg-linear-to-r from-cyan-500 to-cyan-900 opacity-50"></div>
            <div className="flex items-center gap-4 mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-6 h-6 text-cyan-400 shrink-0"
              >
                <rect width="16" height="16" x="4" y="4" rx="2" />
                <rect width="6" height="6" x="9" y="9" rx="1" />
                <path d="M9 1v3" />
                <path d="M15 1v3" />
                <path d="M9 20v3" />
                <path d="M15 20v3" />
                <path d="M20 9h3" />
                <path d="M20 15h3" />
                <path d="M1 9h3" />
                <path d="M1 15h3" />
              </svg>
              <h3 className="text-lg md:text-xl text-gray-50 font-bold leading-snug">
                Volles Spektrum für Ihre Visionen
              </h3>
            </div>
            <p className="text-gray-400 font-sans text-sm leading-relaxed">
              Egal ob konversionsstarke Landingpage, dynamische Webanwendung oder komplexer
              Onlineshop - ich erwecke Ihre Ideen zum Leben. Mit modernen Technologien baue ich
              Plattformen, die performant sind und flexibel mit Ihrem Business mitwachsen.
            </p>
          </div>

          {/* Box 3 */}
          <div className="bg-gray-950 border border-gray-800 p-8 rounded-sm font-mono relative overflow-hidden group hover:border-purple-400/50 transition-colors">
            <div className="absolute top-0 left-0 w-full h-1 bg-linear-to-r from-purple-500 to-purple-900 opacity-50"></div>
            <div className="flex items-center gap-4 mb-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-6 h-6 text-purple-400 shrink-0"
              >
                <path d="M12 12c-2-2.67-4-4-6-4a4 4 0 1 0 0 8c2 0 4-1.33 6-4Zm0 0c2 2.67 4 4 6 4a4 4 0 1 0 0-8c-2 0-4 1.33-6 4Z" />
              </svg>
              <h3 className="text-lg md:text-xl text-gray-50 font-bold leading-snug">
                Alles aus einer Hand
              </h3>
            </div>
            <p className="text-gray-400 font-sans text-sm leading-relaxed">
              Kein Stress mit zig Dienstleistern: Von sauberem Code und SEO über Barrierefreiheit
              bis hin zu professionellem Bildmaterial bekommen Sie bei mir das Komplettpaket. Das
              garantiert schnelle Reaktionszeiten und ein harmonisches Produkt aus einem Guss.
            </p>
          </div>
        </div>
      </ContentWrapper>
    </section>
  );
}
